module.exports = "/assets/4ff6ae97f5d1580682e06a98d9fa7ab0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/FM.png
// module id = 1374
// module chunks = 0